import Menu from '@/assets/menu.svg'
import {type IconProps} from './types'

export const MenuIcon = ({className}: IconProps) => <Menu className={className} />
